<template>
  <div class="container footer">
    <div class="row">
      <div class="col-md-8 d-flex align-items-center">
        <ul class="list-unstyled link-list">
          <li>
            &copy; 2019 Recovinyl
          </li>
          <li>
            <router-link to="/intro">About</router-link>
          </li>
          <li>
            <router-link to="/page/1">Cookie Policy</router-link>
          </li>
          <li>
            <router-link to="/page/2">Privacy Statement</router-link>
          </li>
          <li>
            <router-link to="/page/3">Disclaimer</router-link>
          </li>
        </ul>
      </div>
      <div class="col-md-4 d-flex align-items-center">
        <p class="text-center w-100 text-md-right">
          Avenue Cortenbergh 71<br />
          1000 Brussels<br />
          Belgium<br />
          <a target="_blank" href="mailto:info@recovinyl.com">info@recovinyl.com</a>
        </p>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'SiteFooter',
    components: {

    },
  };

</script>

<style>

</style>